import { render, staticRenderFns } from "./InboundScale.vue?vue&type=template&id=40b42145&scoped=true"
import script from "./InboundScale.vue?vue&type=script&lang=js"
export * from "./InboundScale.vue?vue&type=script&lang=js"
import style0 from "./InboundScale.vue?vue&type=style&index=0&id=40b42145&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b42145",
  null
  
)

export default component.exports